import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Sizes } from '@common/types';
import { Button, Modal } from '@base-app';

import TermsOfServiceHTMLText from './html/HTMLText';
import {
  StyledHelixBuilderLogo,
  StyledHelixLogomark,
  StyledLogoContainer,
  StyledToSFooter,
} from './TermsOfServiceModal.styles';
import { TermsOfServiceModalProps } from './TermsOfServiceModal.types';

const TermsOfServiceModal: FC<TermsOfServiceModalProps> = ({ isLoading, isOpen, onClose, readOnly }) => {
  const { t } = useTranslation();

  const handleClose = (): void => {
    onClose?.();
  };

  return (
    <Modal
      isLocked={!readOnly}
      show={isOpen}
      onClose={handleClose}
      footer={
        <StyledToSFooter>
          <Button onClick={handleClose} disabled={false} loading={isLoading}>
            {readOnly ? t('close') : t('footer.i_agree')}
          </Button>
        </StyledToSFooter>
      }
      title={
        <StyledLogoContainer>
          <StyledHelixLogomark />
          <StyledHelixBuilderLogo />
        </StyledLogoContainer>
      }
      size={Sizes.XX_LARGE}
    >
      <TermsOfServiceHTMLText />
    </Modal>
  );
};

export default TermsOfServiceModal;
